  <template>
  <div>
  <b-modal style="padding:15px" size="lg" id="EditRoleModal" ref="modal" title="Edit Role" ok-title="Submit" cancel-title="Close" 
      @show= "showModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditRoleForm != undefined ? !this.$refs.EditRoleForm.checkValidity() : true">
        <form ref="EditRoleForm" @submit.stop.prevent= "handleSubmit">

          <div class="row"> 
            <div class = "col-md-12">
              <b-form-group label="Role Name" label-for="rolename-input" autocomplete="off">
                <b-form-input id="rolename-input" v-model= "RoleName"  required></b-form-input>
              </b-form-group>
            </div> 
            <div class = "col-md-6" v-if= "$auth.user().companyId == null">
               <b-form-group label="Select Company" label-for="menu-input" autocomplete="off">
                 <b-form-select v-model= "selectedCompanyId" :options="companies" value-field="id" text-field="companyName"  @change="companyChanged()">
                   <b-form-select-option :value = "null" disabled hidden>Please select company</b-form-select-option>
                 </b-form-select>
              </b-form-group>
            </div> 
            <div class="col-md-5">
              <!--NAME INPUT-->
              <b-form-group label="Select Menu" label-for="menu-input" autocomplete="off">
                 <b-form-select v-model= "selectedMenuId" :options="menuHeadings" value-field="id" text-field="name"  @change="getAllMenus()">
                   <b-form-select-option :value = null disabled hidden>All</b-form-select-option>
                 </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-1" style="margin:auto;padding-top:12px;">
              <span @click="clearMenuFilter()">
                <i role = "button" title="clear filter" style="color:grey;" class="fas fa-times"></i>
              </span>
            </div>
          </div>
          
          <div class="col-md-12">
              <b-form-group label="Assigned Rights:">
              <b-form-checkbox-group id="checkbox-group-1" value-field="rightId" text-field="rightName"
                v-model= "checkedRights" :options= "menuRights" name="menuRights"></b-form-checkbox-group>
            </b-form-group>
          </div>  
          
        
        </form>
      </b-modal>
      <Toaster ref = 'toaster'/>
      </div>
      
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../components/toaster'
export default {
    name: 'EditRole',
    data(){
        return{

          moduleName:'Edit Role',
          menuHeadings:[],
          menuRights:[],
          companies:[],
          selectedMenuId:null,
          selectedCompanyId:null,
          // CompanyName: null,
          RoleName : null,
          RoleId:null,
          checkedRights:[],
          unCheckedRights:[],
          
        
		}
  },
  components:{
    Toaster
  },
 props:
 {
   role:{
     type:Object,
     default:null
   }
 }  ,


methods:{
  
getAllCompanies()
{
  axios.post('/company/getall', 
      {"ActiveInActive":1,UserId:this.$auth.user().id})
      .then(res=>{
            if(res.data.status == 1)
            {
              this.companies = res.data.data;
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
},
getMenuHeadings()
{
  axios.get('/company/GetMenuHeadings')
      .then(res=>{
            if(res.data.status == 1)
            {
              this.menuHeadings = res.data.data;
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
},

  EditRole()
  {
    axios.post('/role/edit',
      {"CompanyId":this.selectedCompanyId,"RightIds":this.checkedRights,"RoleName":this.RoleName,"RoleId":this.RoleId})
      .then(res=>{
            if(res.data.status == 1)
           {
               this.$refs.toaster.showToast('Sucess','success','Role has been updated successfully')
                 this.$bvModal.hide('EditRoleModal')
                 this.$parent.getRoles();  
           }
           else
           {
             this.$refs.toaster.showToast('Error','danger',res.data.msg)
           }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },

  clearMenuFilter()
  {
    this.selectedMenuId = null
    this.getAllMenus();
  },

  companyChanged()
  {
    this.checkedRights = [];
    this.getAllMenus();
  },
    getAllMenus()
  {  
    console.log('abc')
     axios.post('/company/GetAssignedRights', 
      {"CompanyId":this.selectedCompanyId,"HeadingId":this.selectedMenuId})
      .then(res=>{
            if(res.data.status == 1)
            {
               this.menuRights = res.data.data.rights;
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },

  
   checkFormValidity() {
        const valid = this.$refs.EditRoleForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.RoleName='';
        this.checkedRights = [];
        this.selectedCompanyId = null;
       
      },
      showModal()
      {
        console.log(this.role)
        this.RoleName = this.role.roleName;
        this.RoleId = this.role.roleId;
        Array.from(this.role.roleRights).forEach(element => {
          element.rights.forEach(item=>{
            
              this.checkedRights.push(item.rightId)
          })
        });
    
        let currentUser = this.$auth.user();
        if(currentUser.userName =="SuperAdmin" && currentUser.companyId == null )
        {
          this.selectedCompanyId = this.role.companyId
        }
        else
        {
          this.selectedCompanyId = currentUser.companyId;
        
        }
        this.getAllCompanies();
        this.getMenuHeadings();
        this.getAllMenus();
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.EditRole()
        
       
      },
 
  
  },
	

}
</script>
